export default "__VITE_ASSET__P9xSFKWS__"